import React from 'react';
import { Award, Shield, TrendingUp, Users } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { companyInfo, services } from '../mock';

export const AboutSection = () => {
  const icons = [Award, Shield, TrendingUp, Users];

  return (
    <section id="about" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            من نحن
          </h2>
          <div className="w-24 h-1 bg-blue-900 mx-auto mb-6"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {companyInfo.description}
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {services.map((service, index) => {
            const Icon = icons[index];
            return (
              <Card
                key={service.id}
                className="border-2 border-gray-100 hover:border-blue-900 transition-all duration-300 hover:shadow-xl group"
              >
                <CardContent className="p-6 text-right">
                  <div className="flex justify-end mb-4">
                    <div className="w-14 h-14 bg-blue-50 rounded-xl flex items-center justify-center group-hover:bg-blue-900 transition-colors">
                      <Icon className="h-7 w-7 text-blue-900 group-hover:text-white transition-colors" />
                    </div>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">
                    {service.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {service.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Additional Info */}
        <div className="bg-gradient-to-r from-blue-50 to-gray-50 rounded-2xl p-8 md:p-12">
          <div className="grid md:grid-cols-2 gap-8 items-center">
            <div className="text-right space-y-4">
              <h3 className="text-3xl font-bold text-gray-900">
                لماذا تختار المعاد الراسخ؟
              </h3>
              <div className="space-y-3">
                <div className="flex items-start gap-3 justify-end">
                  <p className="text-gray-700">خبرة طويلة في مجال قطع غيار السيارات</p>
                  <div className="w-2 h-2 bg-blue-900 rounded-full mt-2"></div>
                </div>
                <div className="flex items-start gap-3 justify-end">
                  <p className="text-gray-700">شبكة واسعة من الموردين المعتمدين</p>
                  <div className="w-2 h-2 bg-blue-900 rounded-full mt-2"></div>
                </div>
                <div className="flex items-start gap-3 justify-end">
                  <p className="text-gray-700">ضمان على جميع المنتجات</p>
                  <div className="w-2 h-2 bg-blue-900 rounded-full mt-2"></div>
                </div>
                <div className="flex items-start gap-3 justify-end">
                  <p className="text-gray-700">فريق دعم فني محترف</p>
                  <div className="w-2 h-2 bg-blue-900 rounded-full mt-2"></div>
                </div>
                <div className="flex items-start gap-3 justify-end">
                  <p className="text-gray-700">مخزون كبير ومتنوع</p>
                  <div className="w-2 h-2 bg-blue-900 rounded-full mt-2"></div>
                </div>
              </div>
            </div>
            <div className="flex justify-center">
              <div className="bg-white rounded-2xl p-8 shadow-lg text-center space-y-4">
                <div className="w-20 h-20 bg-blue-900 rounded-full flex items-center justify-center mx-auto">
                  <Shield className="h-10 w-10 text-white" />
                </div>
                <h4 className="text-2xl font-bold text-gray-900">ضمان الجودة</h4>
                <p className="text-gray-600">
                  نضمن جودة جميع منتجاتنا بنسبة 100%
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};